/**
 * Authors: mariushirjanu, triadiprabowo
 * Created: 03/06/2021
 */
import { Component, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { GaMessageService } from '../message/ga-message.service';
import { FaqPopupDialogComponent } from './faq-popup-dialog.component';

@Component({
  selector: 'faq-popup',
  template:
    `
    <a *ngIf="!label" href="javascript:void(0)" (click)="showFaqInPopup()"><ng-content></ng-content></a>
    <a *ngIf="label" href="javascript:void(0)" (click)="showFaqInPopup()" [innerHTML]="label | translate"></a>
  `,
  styleUrls: [ './faq.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class FaqPopupComponent implements OnChanges {
  @Input() public faqId?:number;
  @Input() public faqCode?:string;
  @Input() public label?:string;

  constructor(
    private messageService:GaMessageService
  ) {/**/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.faqId?.currentValue) {
      this.faqId = parseInt(changes.faqId.currentValue);
    }

    if (changes?.faqCode?.currentValue) {
      this.faqCode = changes.faqCode.currentValue;
    }
  }

  public showFaqInPopup():void {
    this.messageService.showDialog({
      component: FaqPopupDialogComponent,
      wrapperComponent: false,
      inputs: {
        faqId: this.faqId,
        faqCode: this.faqCode,
        title: 'GA.GENERAL.FAQ',
        dialogClass: 'faq-popup'
      }
    });
  }
}